var _defs, _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg20WebemittelDigital(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".aDigital{fill:none;}.bDigital{fill:#707070;}.cDigital{fill:#b3090f;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "aDigital background-transparent",
    width: 96,
    height: 96
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "bDigital",
    d: "M612.811,246.159h-70v-52h70Zm-66-4h62v-44h-62Z",
    transform: "translate(-529.811 -173.158)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cDigital",
    d: "M571.545,222.118h-2.573v-3.536h2.573Zm0,4.245h-2.573v-3.536h2.573Zm0,4.244h-2.573v-3.535h2.573Zm3.085-12.731h-2.572v-3.534h2.572Zm0,4.243h-2.572v-3.536h2.572Zm0,4.245h-2.572v-3.536h2.572Zm0,4.244h-2.572v-3.535h2.572Zm0,4.243h-2.572v-3.535h2.572Zm3.084-16.974h-2.569v-3.534h2.569Zm0,16.974h-2.569v-3.535h2.569Zm3.084-16.974H578.23v-3.534H580.8Zm0,16.974H578.23v-3.535H580.8Zm3.088-25.463h-2.57v-3.537h2.57Zm0,4.242h-2.57V210.1h2.57Zm0,4.245h-2.57v-3.532h2.57Zm0,4.243h-2.57v-3.536h2.57Zm0,4.245h-2.57v-3.536h2.57Zm0,4.244h-2.57v-3.533h2.57Zm0,4.243h-2.57v-3.533h2.57Zm3.087-25.461H584.4v-3.537h2.57Zm0,4.242H584.4V210.1h2.57Zm0,4.245H584.4v-3.532h2.57Zm0,4.243H584.4v-3.536h2.57Zm0,4.245H584.4v-3.536h2.57Zm0,4.244H584.4v-3.533h2.57Zm0,4.243H584.4v-3.533h2.57Z",
    transform: "translate(-529.972 -172.85)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg20WebemittelDigital);
export default __webpack_public_path__ + "static/media/20_webemittel_digital.edc919b48f61a245782114862831def2.svg";
export { ForwardRef as ReactComponent };